import { COUPON_CODES } from '../../constants';
import type { CouponConfigMetadata } from '../interface';

export const monthlyNudgeMetadata: CouponConfigMetadata = {
    coupons: [COUPON_CODES.ANNUALOFFER25],
    hidden: true,
};
